
    import {Component, Vue} from 'vue-property-decorator'
    import GoodsSwipe from "@/components/GoodsSwipe/index.vue";
    import {PackageListDto} from "@/api/buyCar";
    import PackageSelector from "@/components/PackageSelector/index.vue";
    import {Action, Getter} from "vuex-class";
    import {getH5GoodsInfo, getH5GoodsSpecificationList, ShareGoodsDetailDto} from "@/api/share";
    import PackageDialog from "@/views/share/template/PackageDialog.vue";

    @Component({
        name: 'ShareGoodsListDetail',
        components: {GoodsSwipe, PackageSelector, PackageDialog}
    })
    export default class ShareGoodsListDetail extends Vue {
        isInvalid = false // 商品是否已失效

        params = {
            goodsId: "",
            shopId: ""
        }
        detailInfo: ShareGoodsDetailDto = {}
        defaultDetailInfo: ShareGoodsDetailDto = {} // 默认的后端接口返回的数据，用于取消掉规格之后的数据重置
        packageList: PackageListDto[] = []
        onlyOnePackage = false // 判断是否只有一个套餐
        packageName = '' // 套餐名称
        packageWeight = '' // 套餐重量
        selectValueList: string[] = [] // 存储加购弹窗选中的规格，用于加购弹出窗设置默认选中的规格

        created () {
            this.params.shopId = this.$route.query.shopId as string
            this.params.goodsId = this.$route.query.goodsId as string
            this.getInfo()
        }

        /* 获取商品详细信息 */
        getInfo () {
            getH5GoodsInfo(this.params).then((res) => {
                if (res.code === '000000') {
                    this.isInvalid = false
                    this.detailInfo = res.data || {}
                    this.defaultDetailInfo = JSON.parse(JSON.stringify(this.detailInfo))
                    this.getPackageList()
                } else if (res.code === '000002') {
                    this.isInvalid = true
                }
            }).catch(() => {})
        }

        getSelectPackageInfo (info: PackageListDto, selectValueList: string[]) {
            if (selectValueList && selectValueList.length > 0) {
                this.onlyOnePackage = true
                this.packageName = info.packageNameDesc
                this.packageWeight = info.weight
                this.detailInfo.goodsPrice = info.marketPrice
            } else {
                this.detailInfo.goodsPrice = this.defaultDetailInfo.goodsPrice as number
                if (this.defaultDetailInfo.isMultiSpec) {
                    this.onlyOnePackage = false
                    this.packageName = ''
                    this.packageWeight = ''
                } else {
                    this.onlyOnePackage = true
                    this.packageWeight = this.packageList[0] && this.packageList[0].weight
                    this.packageName = this.packageList[0] && this.packageList[0].packageNameDesc
                }
            }
            this.selectValueList = selectValueList
        }

        /**
         * 获取套餐列表
         * */
        getPackageList () {
            getH5GoodsSpecificationList(this.params).then((res) => {
                this.packageList = res.data.packageList || []
                if (this.packageList) {
                    this.onlyOnePackage = this.packageList.length <= 1
                    if (this.onlyOnePackage) {
                        this.packageWeight = this.packageList[0] && this.packageList[0].weight
                        this.packageName = this.packageList[0] && this.packageList[0].packageNameDesc
                    }
                }
            }).catch(() => {})
        }

        /**
         * 打开选择规格弹窗
         * @param type ’1‘加入购物车  ’2‘立即下单  ’3‘选择规格可加购可下单
         */
        showRules(type = '4') {
            (this.$refs.packageSelector as any).show({
                ruleType: type,
                detailInfo: this.detailInfo,
                selectList: this.selectValueList,
                defaultInfo: this.defaultDetailInfo,
            })

            // isOptionalGoods(this.params).then((res) => {
            //     if (res.data.isOptional) {
            //         (this.$refs.packageSelector as any).show({
            //             ruleType: type,
            //             detailInfo: this.detailInfo,
            //             selectList: this.selectValueList
            //         })
            //     } else {
            //         this.$dialog.alert({
            //             message: '商品过期不存在'
            //         }).then(() => {
            //             // this.$router.back()
            //             // window.sessionStorage.setItem('refresh', '1')
            //         })
            //     }
            // }).catch(() => {
            // })
        }

    }
